<template>
    <div class="album albumvideo">
        <div>
            <div class="upload-avatar">
                <div class="avatar-item" v-for="(imageItem, imageIndex) in data" :key="imageIndex">
                    <img width="100" src="../../assets/img/music.png">
                    <span class="upload-list__item-actions">
            <el-popover
                    placement="right"
                    width="600"
                    trigger="click">
                 <audio :src="imageItem" controls="controls">您的浏览器不支持音频播放</audio>
              <span class="upload-list__item-preview" slot="reference">
            <el-icon class="el-icon-video-play"></el-icon>
            </span>
</el-popover>

            <span class="upload-list__item-delete" @click.stop="reMainVip(imageIndex)">
              <el-icon class="el-icon-delete"></el-icon>
            </span>
          </span>
                </div>
            </div>
            <div class="pic_img">
                <div class="pic_img_box" style="display: flex;">
                    <el-upload
                            v-if="data.length < max"
                            class="avatar-uploader"
                            :auto-upload="false"
                            action=""
                            :on-change="handleFileSelect"
                            :show-file-list="false"
                            :file-list="data"
                    >
                    <span v-if="pendingFile" style="align-self:center;margin-left:10px;color:#409EFF;max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                      更换音频
                    </span>
                        <i v-else class="el-icon-plus"></i>
                        <el-progress
                                v-if="videoFlag == true"
                                type="circle"
                                v-bind:percentage="videoUploadPercent"
                                style="margin-top:7px;"
                        ></el-progress>
                        <div slot="tip" class="el-upload__tip">
                            <span>音频要求</span>
                            <span v-for="(vv, ii) in text" :key="ii">{{ ii + 1 }}.{{ vv }}</span>
                            <span>{{ text.length + 1 }}.最多上传{{ max }}个</span>
                        </div>
                    </el-upload>
                    <!-- 选中文件名 -->

                </div>
            </div>
        </div>
        <select-file :value="data" :size="max" :file-type="1" @change="fileChanged"></select-file>
               <!-- 提示 -->
             <div>
                <span v-if="pendingFile" style="align-self:center;margin-left:10px;color:#FF0000;max-width:240px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">
                      不支持的音频格式 点击下方按钮“开始转码”
                    </span>
             </div>
        <el-button
                      v-if="pendingFile && !videoFlag"
                      type="primary"
                      size="mini"
                      @click="startConvert"
                      style="margin-top:8px">
                      开始转码
                    </el-button>

    </div>
</template>
<script>
import { getToken } from '@/api/demo/classification/index'
import selectFile from '@/components/file/selectFile.vue'
import { oggToP3 } from '@/utils/ffmpegP3'

export default {
  components: { selectFile },
  name: 'uploadAudio',
  model: {
    prop: 'filterManage',
    event: 'change'
  },
  props: {
    max: {
      type: Number,
      default: 1
    },
    filterManage: {
      type: Array | String,
      default: () => []
    },
    text: {
      type: Array,
      default: () => ['音频大小100MB以内', '图片格式png/jpg']
    }
  },
  data () {
    return {
      // 内部文件列表，避免直接修改 props
      innerData: [],
      // 七牛上传图片
      uploadUrl: 'https://up-z2.qiniup.com',
      uploadData: { key: '', token: '' },
      https: null,
      resHttps: [],
      videoFlag: false,
      // 是否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      isShowUploadVideo: false,
      // loading 实例
      loadingInstance: null,
      // 用户已选择待转码的文件
      pendingFile: null
    }
  },
  created () {
    this.getTokened()
  },
  computed: {
    // 通过计算属性暴露文件列表，并提供 setter 避免 Vue 警告
    data: {
      get () {
        return this.innerData
      },
      set (val) {
        this.innerData = Array.isArray(val) ? val : (val ? [val] : [])
      }
    }
  },
  methods: {
    fileChanged (value) {
      if (this.max === 1) {
        this.data = [value]
      } else {
        this.data = value
      }
      this.$emit(
        'change',
        value
      )
    },
    getTokened () {
      let that = this
      getToken({}).then(res => {
        that.uploadData.token = res.token
        that.https = res.domain
        // 初始化内部数据
        if (typeof that.filterManage === 'string') {
          that.innerData = that.filterManage ? [that.filterManage] : []
        } else {
          that.innerData = Array.isArray(that.filterManage) ? [...that.filterManage] : []
        }
      })
    },
    /**
         * 选择文件后的回调 —— 负责校验、转码并上传
         * 返回 false 阻止 el-upload 默认上传
         */
    async handleFileSelect (file) {
      const rawFile = file.raw || file
      // 1. 基础校验
      const allowTypes = [
        'audio/mpeg', // .mp3
        'audio/mp3',
        'audio/ogg', // .ogg, .opus
        'audio/opus',
        'audio/wav',
        'audio/x-wav',
        'audio/aac',
        'audio/mp4', // .m4a
        'audio/m4a',
        'audio/x-m4a',
        'audio/flac'
      ]
      const ext = (rawFile.name || '').toLowerCase().split('.').pop()
      const allowExts = ['mp3', 'wav', 'ogg', 'opus', 'aac', 'm4a', 'flac']
      const isValidType = allowTypes.includes(rawFile.type) || allowExts.includes(ext)
      const isValidSize = rawFile.size / 1024 / 1024 < 100

      if (!isValidType) {
        this.$message.error('请上传正确的音频格式')
        return false
      }
      if (!isValidSize) {
        this.$message.error('音频大小不能超过100MB')
        return false
      }

      // 2. 暂存文件，等待用户点击开始上传
      this.pendingFile = rawFile
      this.$message.info('文件已选择，请点击"开始转码"')
      return false // 阻止 el-upload 默认上传
    },
    /** 用户点击 "开始上传" 按钮 */
    async startConvert () {
      if (!this.pendingFile) {
        this.$message.warning('请先选择音频文件')
        return
      }

      const rawFile = this.pendingFile

      // 生成上传 key 使用 uuid + .p3
      const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 0xf) >> (c === 'x' ? 0 : 1)
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
      const extKey = `${uuid}.p3`
      this.uploadData.key = extKey

      // 3. Loading 动画
      console.log('[upload] start loading & convert')
      this.loadingInstance = this.$loading({
        lock: true,
        text: '音频转码中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      try {
        // 4. 转码为 p3 (耗时操作，FFmpeg 使用 worker)
        const p3Buf = await this.transcodeInIsolated(rawFile)
        console.log('p3 buffer size', p3Buf.length)

        // 更新 loading 文案
        if (this.loadingInstance) this.loadingInstance.setText('上传中...')

        // 5. 上传到七牛
        const blob = new Blob([p3Buf], { type: 'application/octet-stream' })
        const formData = new FormData()
        formData.append('file', blob, extKey)
        formData.append('key', extKey)
        formData.append('token', this.uploadData.token)

        await this.$axios.post(this.uploadUrl, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (event) => {
            this.videoFlag = true
            this.videoUploadPercent = Math.floor((event.loaded / event.total) * 100)
          }
        })

        // 6. 成功回调封装
        this.videoFlag = false
        this.videoUploadPercent = 0

        const audioUrl = `${this.https}/${extKey}`
        if (this.max === 1) {
          this.data = [audioUrl]
          this.$emit('change', audioUrl)
        } else {
          this.data.push(audioUrl)
          this.$emit('change', this.data.map(i => i))
        }

        this.$message.success('音频上传成功')
      } catch (e) {
        console.error(e)
        this.$message.error('音频转码或上传失败')
        this.videoFlag = false
        this.videoUploadPercent = 0
      } finally {
        if (this.loadingInstance) this.loadingInstance.close()
      }

      this.pendingFile = null // 清空
      return false
    },
    // 进度条
    uploadVideoProcess (event, file, fileList) {
      console.log(file, 'filefilefilefilefilefile')
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    // 上传成功回调
    skuImg (res, file, flList) {
      let that = this
      that.isShowUploadVideo = true
      that.videoFlag = false
      that.videoUploadPercent = 0
      console.log('that.https + "/" + res.key', that.https + '/' + res.key)
      if (flList.length > that.max) {
        that.$message.info(`最大上传${that.max}个音频`)
        return
      }

      const audioUrl = that.https + '/' + res.key

      // 根据max值决定如何处理数据
      if (that.max === 1) {
        // 单个文件模式，替换现有数据
        that.data = [audioUrl]
        // 如果原始数据是字符串类型，返回字符串
        this.$emit('change', audioUrl)
      } else {
        // 多个文件模式，添加到数组
        that.data.push(audioUrl)
        this.$emit('change', that.data.map(item => item))
      }
    },
    reMainVip (index) {
      if (this.max === 1) {
        this.innerData = []
        this.$emit('change', '')
      } else {
        const newArr = this.innerData.filter((_, i) => i !== index)
        this.innerData = newArr
        this.$emit('change', newArr.map(item => item))
      }
    },
    /**
         * 在子窗口（/tools/p3.html）中执行 ffmpeg-wasm 转码，主线程只解析 ogg->p3
         * @param {File|Blob} rawFile
         * @returns {Promise<Uint8Array>} p3 buffer
         */
    transcodeInIsolated (rawFile) {
      return new Promise((resolve, reject) => {
        const channelName = 'p3_' + Date.now() + Math.random().toString(16).slice(2)
        const bc = new BroadcastChannel(channelName)

        console.log('[p3] open window start')
        window.open('/tools/p3.html?ch=' + encodeURIComponent(channelName), '_blank', 'noopener,width=120,height=120')
        console.log('[p3] window open triggered')

        let sent = false
        const sendFile = () => {
          if (sent) return
          console.log('[p3] -> send file')
          bc.postMessage(rawFile)
          sent = true
        }

        const handle = (e) => {
          console.log('[p3] message from child', e)
          const data = e.data || {}
          if (data.type === 'ready') {
            sendFile()
            return
          }
          if (data.type === 'opus' && data.buffer) {
            console.log('[p3] received opus buffer size', data.buffer.byteLength)
            bc.removeEventListener('message', handle)
            try {
              const p3 = oggToP3(new Uint8Array(data.buffer))
              resolve(p3)
            } catch (err) {
              reject(err)
            }
          } else if (data.type === 'error') {
            bc.removeEventListener('message', handle)
            reject(new Error(data.message || '子页面转码失败'))
          }
        }

        bc.addEventListener('message', handle)

        // 若 ready 丢失，2s 后强制发送一次
        setTimeout(sendFile, 2000)
      })
    }
  },
  mounted () {
    if (typeof this.filterManage === 'string') {
      this.innerData = this.filterManage ? [this.filterManage] : []
    } else if (Array.isArray(this.filterManage)) {
      this.innerData = [...this.filterManage]
    }
  }
}
</script>
<style type="text/scss" lang="scss" scoped>
.upload-avatar,
.zgu-upload {
  display: flex;
}

.el-upload__tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  line-height: 16px;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.avatar-item {
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  line-height: 100px;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  margin: 0 8px 8px 0;
  display: inline-block;
}

.upload-list__item-actions {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s;

  &:hover {
    opacity: 1;
    cursor: pointer;
  }

  .upload-list__item-delete {
    margin-left: 15px;
  }
}
</style>
<style lang="scss">
.avatar-uploader {
  display: flex;
}

.el-upload {
  text-align: center;
  cursor: pointer;
  outline: 0;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0.5px solid #666;
}

.el-upload--picture-card,
.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 100px;
}
</style>
